module.exports = __webpack_public_path__ + "static/media/img-user-empty.146b54b4.svg";